import isEmpty from 'lodash.isempty';
import { INCENTIVE_TYPE_VALUES } from '@makemydeal/dr-dash-types';
import type { ManualIncentiveEntry } from '@makemydeal/dr-platform-types';
import type { ManualIncentiveEditEntry } from '../types/manualIncentiveTypes';

const toEditableIncentiveType = (storedType: string): string =>
    storedType === INCENTIVE_TYPE_VALUES.dealerCash.value
        ? INCENTIVE_TYPE_VALUES.dealerCash.value
        : INCENTIVE_TYPE_VALUES.customerCash.value;

const resolveStoredIncentiveType = (incentive: ManualIncentiveEntry): string => {
    if (incentive.type) {
        return incentive.type;
    }
    const programIncentiveType = (incentive as { incentiveType?: string }).incentiveType;
    return programIncentiveType ? toEditableIncentiveType(programIncentiveType) : '';
};

export const transformToManualEditIncentive = (incentive: ManualIncentiveEntry): ManualIncentiveEditEntry => {
    return {
        ...incentive,
        originalAmount: incentive.originalAmount || incentive.amount,
        deleted: incentive.deleted ?? false,
        type: resolveStoredIncentiveType(incentive)
    } as ManualIncentiveEditEntry;
};
export const transformToEditIncentive = (
    term: any,
    incentives: ManualIncentiveEntry[],
    generateIds?: boolean
): ManualIncentiveEditEntry[] => {
    if (incentives) {
        return incentives.map((inc, index) => {
            const amount = transformIncentiveAmount(term, inc);

            return {
                ...transformToManualEditIncentive({ ...inc, amount }),
                ...(generateIds && { _editId: (inc as ManualIncentiveEditEntry)._editId || `edit-${Date.now()}-${index}` })
            };
        });
    }
    return [];
};

export const isOriginalIncentive = ({ name, description }: ManualIncentiveEntry | ManualIncentiveEditEntry): boolean =>
    !isEmpty(description) && description !== name;

export const sortStandardIncentivesFirst = (entries: ManualIncentiveEditEntry[]): ManualIncentiveEditEntry[] => {
    const standard = entries.filter((entry) => entry.isStandardIncentive);
    const rest = entries.filter((entry) => !entry.isStandardIncentive);
    return [...standard, ...rest];
};

export function transformIncentiveAmount(term: any, incentive: any) {
    let newIncentiveAmount = incentive?.amount;

    if (newIncentiveAmount === 0) {
        const termRangeList = incentive.termRebates?.incentiveTermRange || [];
        termRangeList.forEach((termRange: any) => {
            if (term >= termRange.startTerm && term <= termRange.endTerm) {
                newIncentiveAmount = termRange.customerCash;
            }
        });
    }

    return newIncentiveAmount;
}
